// not using enum but class because
// its easier to handle than enum -
// you cant extend or copy an enum

export class TS_SelectType {
    static SINGLE   = "SINGLE";
    static MULTIPLE = "MULTIPLE";
}